import React from 'react';
import '../styles/ReportLoadingAnimation.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

function ReportLoadingAnimation() {

    return (
        <div className="report-loading-animation-container">
            <div className="report-loading-animation-text-container">
                <h1 className="heading-large-bold colour-white text-align-center">
                    Retrieving all comps
                </h1>
                <span className="body-regular colour-tertiary block-text text-align-center">
                    This should take about 5 minutes
                </span>
                <span className="body-regular colour-tertiary block-text text-align-center">
                    (ask us about the CRM integration to automate this 😉)
                </span>
            </div>
            <div className="report-loading-animation-lottie-container">
                <DotLottieReact
                    src="https://lottie.host/de271e67-e8d1-4b29-903b-ee349c371ee6/jnONA5xh2L.lottie"
                    loop
                    autoplay
                />
            </div>
        </div>
    )
}

export default ReportLoadingAnimation;